import { useEffect, useState } from "react";
import { Link as RouterLink, Navigate } from "react-router-dom";
import { Box, Button, Container, Grid, Paper, Stack, Typography, Divider } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { CustomerController } from "../controllers/customer";

export default function Account() {
  const { user, logout, loading } = useAuth();
  const [account, setAccount] = useState(null);

  useEffect(() => {
    if (user) CustomerController.get().then(setAccount).catch(() => setAccount(null));
  }, [user]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Typography variant="h2" sx={{ fontSize: "1.8rem" }}>My Account</Typography>
        <Button onClick={logout} variant="outlined">Sign Out</Button>
      </Stack>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h3" sx={{ fontSize: "1rem", mb: 2 }}>Profile</Typography>
            <Box>
              <Typography variant="body2" color="text.secondary">Name</Typography>
              <Typography>{[user.firstName, user.lastName].filter(Boolean).join(" ") || "—"}</Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
            <Box>
              <Typography variant="body2" color="text.secondary">Email</Typography>
              <Typography>{user.email || "—"}</Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
            <Box>
              <Typography variant="body2" color="text.secondary">Company</Typography>
              <Typography>{account?.company || user.company || "—"}</Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h3" sx={{ fontSize: "1rem", mb: 2 }}>Quick Links</Typography>
            <Stack spacing={1}>
              <Button component={RouterLink} to="/quotes" variant="contained">My Quotes</Button>
              <Button component={RouterLink} to="/orders" variant="outlined">My Orders</Button>
              <Button component={RouterLink} to="/cart" variant="outlined">Current Cart</Button>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
